import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {noop} from '@angular/core/src/linker/view_utils';
import isEqual = require('lodash/isEqual');

// region NG_VALUE_ACCESSOR
const MY_MULTISELECTOR_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MultiselectorComponent),
    multi: true
};
// endregion

let nextUniqueId = 0;

/**
 * Created by Arturo Campos on 08/02/17.
 */
@Component({
    selector: 'my-multiselector',
    template: require('./multiselector.component.html'),
    styles: [require('./multiselector.component.scss')],
    providers: [MY_MULTISELECTOR_CONTROL_VALUE_ACCESSOR]
})
export class MultiselectorComponent implements ControlValueAccessor {
    readonly id = `my-multiselector-${++nextUniqueId}`;

    private _value?: Array<string>;

    // region Input
    @Input() label: string;
    @Input() name: string|null = null;
    @Input() errorMessage: String;
    @Input() errorMessagePosition: String = 'right';
    @Input() onlyFromAutocomplete: boolean = false;
    @Input() placeholder: string|null = null;
    @Input() secondaryPlaceholder: string|null = null;
    @Input() options: Array<string> = [];
    // endregion

    @Input() get value(): Array<string>|undefined {
        return this._value;
    }

    set value(value: Array<string>|undefined) {
        if (!isEqual(this._value, value)) {
            this._value = value;
            this._onChangeCallback(this._value);
        }
    }

    // region ControlValueAccessor
    /** Callback registered via registerOnTouched (ControlValueAccessor) */
    private _onTouchedCallback: () => void = noop;
    /** Callback registered via registerOnChange (ControlValueAccessor) */
    private _onChangeCallback: (_: any) => void = noop;

    writeValue(value: Array<string>|undefined): void {
        this._value = value ? value : undefined;
    }

    registerOnChange(fn: any): void {
        this._onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this._onTouchedCallback = fn;
    }
    // endregion
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/multiselector/multiselector.component.ts